import React, { useState } from 'react';
import { Home, FileText, Clock, FolderOpen, Users, BarChart, Settings, HelpCircle, MessageSquare, Calendar, Star, ChevronRight, ChevronDown } from 'lucide-react';
export const Sidebar = ({
  activeModule,
  setActiveModule
}) => {
  const [expandedMenus, setExpandedMenus] = useState({
    documents: false,
    workflows: false,
    users: false
  });
  const toggleMenu = menu => {
    setExpandedMenus({
      ...expandedMenus,
      [menu]: !expandedMenus[menu]
    });
  };
  const handleModuleClick = module => {
    setActiveModule(module);
    // If the module has a submenu, toggle it
    if (expandedMenus.hasOwnProperty(module)) {
      toggleMenu(module);
    }
  };
  return <aside className="bg-white border-r border-gray-200 w-64 flex-shrink-0 hidden lg:block" data-id="element-935">
      <div className="h-full flex flex-col" data-id="element-936">
        <div className="overflow-y-auto flex-1 py-4" data-id="element-937">
          <nav className="px-2 space-y-1" data-id="element-938">
            {/* Dashboard */}
            <SidebarItem icon={<Home className="h-5 w-5" data-id="element-940" />} label="Dashboard" active={activeModule === 'dashboard'} onClick={() => handleModuleClick('dashboard')} data-id="element-939" />
            {/* Documents */}
            <div data-id="element-941">
              <SidebarItemWithSubmenu icon={<FileText className="h-5 w-5" data-id="element-943" />} label="Documents" active={activeModule === 'documents'} expanded={expandedMenus.documents} onClick={() => handleModuleClick('documents')} onToggle={() => toggleMenu('documents')} data-id="element-942" />
              {expandedMenus.documents && <div className="pl-10 space-y-1 mt-1" data-id="element-944">
                  <SidebarSubItem label="All Documents" onClick={() => setActiveModule('documents')} data-id="element-945" />
                  <SidebarSubItem label="My Documents" onClick={() => setActiveModule('documents')} data-id="element-946" />
                  <SidebarSubItem label="Shared with Me" onClick={() => setActiveModule('documents')} data-id="element-947" />
                  <SidebarSubItem label="Recent" onClick={() => setActiveModule('documents')} data-id="element-948" />
                </div>}
            </div>
            {/* Workflows */}
            <div data-id="element-949">
              <SidebarItemWithSubmenu icon={<Clock className="h-5 w-5" data-id="element-951" />} label="Workflows" active={activeModule === 'workflows'} expanded={expandedMenus.workflows} onClick={() => handleModuleClick('workflows')} onToggle={() => toggleMenu('workflows')} data-id="element-950" />
              {expandedMenus.workflows && <div className="pl-10 space-y-1 mt-1" data-id="element-952">
                  <SidebarSubItem label="Active Workflows" onClick={() => setActiveModule('workflows')} data-id="element-953" />
                  <SidebarSubItem label="My Tasks" onClick={() => setActiveModule('workflows')} data-id="element-954" />
                  <SidebarSubItem label="Completed" onClick={() => setActiveModule('workflows')} data-id="element-955" />
                  <SidebarSubItem label="Templates" onClick={() => setActiveModule('workflows')} data-id="element-956" />
                </div>}
            </div>
            {/* Archives */}
            <SidebarItem icon={<FolderOpen className="h-5 w-5" data-id="element-958" />} label="Archives" active={activeModule === 'archives'} onClick={() => handleModuleClick('archives')} data-id="element-957" />
            {/* Users */}
            <div data-id="element-959">
              <SidebarItemWithSubmenu icon={<Users className="h-5 w-5" data-id="element-961" />} label="Users & Groups" active={activeModule === 'users'} expanded={expandedMenus.users} onClick={() => handleModuleClick('users')} onToggle={() => toggleMenu('users')} data-id="element-960" />
              {expandedMenus.users && <div className="pl-10 space-y-1 mt-1" data-id="element-962">
                  <SidebarSubItem label="All Users" onClick={() => setActiveModule('users')} data-id="element-963" />
                  <SidebarSubItem label="Departments" onClick={() => setActiveModule('users')} data-id="element-964" />
                  <SidebarSubItem label="Permissions" onClick={() => setActiveModule('users')} data-id="element-965" />
                </div>}
            </div>
            {/* Reports */}
            <SidebarItem icon={<BarChart className="h-5 w-5" data-id="element-967" />} label="Reports" active={activeModule === 'reports'} onClick={() => handleModuleClick('reports')} data-id="element-966" />
            {/* Calendar */}
            <SidebarItem icon={<Calendar className="h-5 w-5" data-id="element-969" />} label="Calendar" active={activeModule === 'calendar'} onClick={() => handleModuleClick('calendar')} data-id="element-968" />
            {/* Messages */}
            <SidebarItem icon={<MessageSquare className="h-5 w-5" data-id="element-971" />} label="Messages" active={activeModule === 'messages'} onClick={() => handleModuleClick('messages')} badge="5" data-id="element-970" />
          </nav>
        </div>
        {/* Favorites Section */}
        <div className="px-3 py-3 border-t border-gray-200" data-id="element-972">
          <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-973">
            Favorites
          </h3>
          <div className="mt-2 space-y-1" data-id="element-974">
            <FavoriteItem label="Annual Budget 2023" type="document" data-id="element-975" />
            <FavoriteItem label="Department Meeting Notes" type="document" data-id="element-976" />
            <FavoriteItem label="Budget Approval" type="workflow" data-id="element-977" />
          </div>
        </div>
        {/* Bottom Section */}
        <div className="px-3 py-3 border-t border-gray-200" data-id="element-978">
          <div className="space-y-1" data-id="element-979">
            <SidebarItem icon={<Settings className="h-5 w-5" data-id="element-981" />} label="Settings" active={activeModule === 'settings'} onClick={() => handleModuleClick('settings')} compact data-id="element-980" />
            <SidebarItem icon={<HelpCircle className="h-5 w-5" data-id="element-983" />} label="Help & Support" active={activeModule === 'help'} onClick={() => handleModuleClick('help')} compact data-id="element-982" />
          </div>
        </div>
      </div>
    </aside>;
};
const SidebarItem = ({
  icon,
  label,
  active,
  onClick,
  badge,
  compact = false
}) => {
  return <button className={`flex items-center w-full ${compact ? 'px-2 py-1.5' : 'px-3 py-2'} rounded-md text-sm font-medium ${active ? 'bg-blue-50 text-blue-700' : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900'}`} onClick={onClick} data-id="element-984">
      <span className={`${active ? 'text-blue-600' : 'text-gray-500 group-hover:text-gray-500'}`} data-id="element-985">
        {icon}
      </span>
      <span className="ml-3 flex-1 whitespace-nowrap" data-id="element-986">{label}</span>
      {badge && <span className="ml-auto bg-blue-100 text-blue-800 text-xs font-semibold px-2 py-0.5 rounded" data-id="element-987">
          {badge}
        </span>}
    </button>;
};
const SidebarItemWithSubmenu = ({
  icon,
  label,
  active,
  expanded,
  onClick,
  onToggle
}) => {
  return <div className="relative" data-id="element-988">
      <button className={`flex items-center w-full px-3 py-2 rounded-md text-sm font-medium ${active ? 'bg-blue-50 text-blue-700' : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900'}`} onClick={onClick} data-id="element-989">
        <span className={`${active ? 'text-blue-600' : 'text-gray-500 group-hover:text-gray-500'}`} data-id="element-990">
          {icon}
        </span>
        <span className="ml-3 flex-1 whitespace-nowrap" data-id="element-991">{label}</span>
        <button className="ml-auto focus:outline-none" onClick={e => {
        e.stopPropagation();
        onToggle();
      }} data-id="element-992">
          {expanded ? <ChevronDown className="h-4 w-4 text-gray-500" data-id="element-993" /> : <ChevronRight className="h-4 w-4 text-gray-500" data-id="element-994" />}
        </button>
      </button>
    </div>;
};
const SidebarSubItem = ({
  label,
  onClick
}) => {
  return <button className="flex items-center w-full px-2 py-1.5 text-xs font-medium text-gray-600 rounded-md hover:bg-gray-50 hover:text-gray-900" onClick={onClick} data-id="element-995">
      {label}
    </button>;
};
const FavoriteItem = ({
  label,
  type
}) => {
  const icon = type === 'document' ? <FileText className="h-4 w-4 text-gray-500" data-id="element-996" /> : <Clock className="h-4 w-4 text-gray-500" data-id="element-997" />;
  return <button className="flex items-center w-full px-2 py-1.5 text-xs font-medium text-gray-600 rounded-md hover:bg-gray-50 hover:text-gray-900" data-id="element-998">
      {icon}
      <span className="ml-2 truncate" data-id="element-999">{label}</span>
      <Star className="h-3 w-3 ml-auto text-yellow-500" data-id="element-1000" />
    </button>;
};